import { customMessageAction } from '../extensions';
import { CAST_MESSAGES } from '../../config/receiver';
import { CustomCommands } from '../../types';
import { PluginInterface } from './PluginInterface';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';

export class ReloadPlugin implements PluginInterface {
  init(context: CastReceiverContext) {
    customMessageAction.register(request => {
      const command = request.data.command as CustomCommands;
      if (command === 'RELOAD') {
        // @ts-expect-error: This is not in the official types
        window.location.reload(0);

        context.sendCustomMessage(CAST_MESSAGES.CUSTOM, request.senderId, {
          command,
          status: 'reloading',
        });
      }
    });
  }
}
